// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle_pageTitle__ZxQ1+","title":"PageTitle_title__woV0W","subTitle":"PageTitle_subTitle__yddJh"};